module.exports = __webpack_public_path__ + "img/teamTmp.c97b5629.png";